import { defineStore } from 'pinia'
import { shallowRef } from 'vue'
import { toast } from '@/lib/toast';
import i18n from '@/plugins/i18n';

export const useAppBarComponentStore = defineStore('appBarComponent', () => {
    const currentComponent = shallowRef(null)

    function openComponent(component, props = {})
    {
        try {
            currentComponent.value = { component, props };
        } catch (error) {
            toast.error(i18n.global.t(`Не удалось открыть компонент. Ошибка: {_1}`, {'_1': error.message}))
        }
    }

    return { currentComponent, openComponent }
})